import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/themeco': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M202.9 8.4c9.9-5.7 26-5.8 35.9-0.2l191.2 107.6c10 5.6 18 19.4 18 30.9v217.3c0 11.4-8.1 25.3-18 31l-191.2 108.7c-9.9 5.7-26 5.6-35.8-0.2l-185.1-108.4c-9.9-5.8-17.9-19.7-17.9-31.1v-217.3c0-11.4 8-25.4 17.9-31.1zM125.5 208.3c-15.9 0-31.9 0.1-47.8 0.1v101.4h19.1v-29.8h28.7c49.7 0 49.6-71.7 0-71.7zM265.6 308.6l-30.7-34.6c37-7.5 34.8-65.2-10.9-65.5-16.1 0-32.2-0.1-48.3-0.1v101.6h19.1v-33.9h18.4l29.6 33.9h22.8v-1.3zM224.1 226.2c23.3 0 23.3 32.5 0 32.5h-29.1v-32.5h29.1zM128.5 224.6c21.2 0 21.1 38.9 0 38.9h-32.3v-38.8zM321.1 206.4c-68.5 0-71 105.8 0 105.8 69.5 0 69.4-105.8 0-105.8zM321.1 223.8c44.1 0 44.8 70.9 0 70.9-44.8 0-44.4-70.9 0-70.9z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/themeco.js
// module id = 1051
// module chunks = 0